// Site Ayarları - Merkezi Konfigürasyon

export const DEFAULT_SHIPPING = {
  fee: 49.90,
  freeShippingThreshold: 500,
  enabled: true,
  carrier: 'Yurtiçi Kargo'
};

// DB'den kargo ayarlarını çek, fallback olarak default kullan
export const fetchShippingSettings = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/settings/shipping`);
    if (response.ok) {
      const data = await response.json();
      return { ...DEFAULT_SHIPPING, fee: data.fee, freeShippingThreshold: data.freeShippingThreshold };
    }
  } catch (error) {
    console.error('Shipping settings fetch error:', error);
  }
  return DEFAULT_SHIPPING;
};

// Eski sync versiyon — localStorage cache kullan (fallback)
export const getShippingSettings = () => {
  const saved = localStorage.getItem('shippingSettings');
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (error) {
      console.error('Shipping settings parse error:', error);
    }
  }
  return DEFAULT_SHIPPING;
};

// Admin panelden kaydet (localStorage cache + DB sync)
export const saveShippingSettings = (settings) => {
  localStorage.setItem('shippingSettings', JSON.stringify(settings));
};
